export default "__VITE_ASSET__BAn0UTbl__"